import { ValidationError } from '@givz/core-client';
import { atom, selector } from 'recoil';

export const notificationErrorState = atom<
  ValidationError[] | string | undefined
>({
  default: undefined,
  key: 'notificationErrorState',
});

export const notificationSuccessState = atom<string | undefined>({
  default: undefined,
  key: 'notificationSuccessState',
});

export const notificationErrorSelector = selector<string | undefined>({
  get: ({ get }) => {
    const errors = get(notificationErrorState);
    if (typeof errors !== 'object') return errors;
    // sort so errors without fields are first
    return [...errors]
      .sort((a, b) => {
        if ('field' in a === 'field' in b) return 0;
        else if (!a.field) return -1;
        return 1;
      })
      .map(({ field, message }) => (field ? `${field}: ${message}` : message))
      .join('; ');
  },
  key: 'notificationErrorSelector',
});
